// src/modules/users/usersApi.js
export const getUsers = async (token) => {
  const res = await fetch(`${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/users`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to load users");
  return res.json();
};

export const addUser = async (user, token) => {
  const res = await fetch(`${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/users`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });
  if (!res.ok) throw new Error("Failed to add user");
  return res.json();
};

export const deleteUser = async (userId, token) => {
  const res = await fetch(`${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/users/${userId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to delete user");
  return res.json();
};

// 🔍 Corrected: Graph search endpoint + param = "q"
export const searchGraphUsers = async (query, token) => {
  if (!query) return [];
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/graph/users/search?q=${encodeURIComponent(query)}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to search users");
  return res.json(); // returns [{ id, name, email, jobTitle }]
};

export const getCurrentUserRole = async (email, token) => {
  const url = `${process.env.REACT_APP_PROD_SCHEDULE_API_URL}/me?email=${encodeURIComponent(email)}`;
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Failed to fetch current user role");
  return await response.json();
};
